module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"views.dialogProductCategory.tabs.usage":"Usage"}}')
  delete Component.options._Ctor
}
